export default {"src":"/_next/static/media/phone_bg_wide.ea3ba8a0.svg","height":107,"width":493,"blurWidth":0,"blurHeight":0};